import type { RouteDetailEntry } from '../../../types'

export function sortEntriesByFirstEvent(entryA: RouteDetailEntry, entryB: RouteDetailEntry) {
  if (entryA.start && entryA.start.type === 'routeStart') return -1
  if (entryB.start && entryB.start.type === 'routeStart') return 1

  return 0
}
